import "./Header.css";
import Logo from './../../img/mazen-logo.png';
import CV from "./../../assets/MazenHassani.pdf";
export function Header() {
  return (
    <header className="header">
       <div className="name-position">
        <img class="logo" src={Logo}/>
        <div>
        <h1 className="title">MAZEN HASSANI</h1>
        <p>ROBOTIC ENGINEER</p>
        </div>
      </div>
      <a className="download" href={CV} download="proposed_file_name">Download My CV</a>

    </header>
  );
}
